import { enUS, nlNL } from '@mui/x-date-pickers/locales';
import i18n from '../../../localization/i18next';
export function getDatePickerLocaleText() {
    var language = i18n.language;
    switch (language) {
        case 'en':
            return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
        case 'nl':
            return nlNL.components.MuiLocalizationProvider.defaultProps.localeText;
        default:
            return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    }
}
